import { render, staticRenderFns } from "./MultiSlots.vue?vue&type=template&id=f0977baa"
import script from "./MultiSlots.vue?vue&type=script&lang=js"
export * from "./MultiSlots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports